export enum FeeType {
  NONE = "NONE",
  PERCENTAGE = "PERCENTAGE",
  FIXED = "FIXED",
  PERCENTAGE_AND_FIXED = "PERCENTAGE_AND_FIXED",
  PERCENTAGE_WITH_MIN_FIXED = "PERCENTAGE_WITH_MIN_FIXED",
  FIXED_WITH_LIMIT = "FIXED_WITH_LIMIT",
  FIXED_DUAL_LIMIT = "FIXED_DUAL_LIMIT",
}
